import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | Peak` : 'Peak - Budget Management';
  }, [title]);
}
